<template>
  <div class="newsfeed">
    <post-form
      :entity-id="teamId"
      entity="Team"
      access-level="Public"
      content-type="html"
      @update-data="fetchPosts"
      :is-new="true"
      v-if="isUserLoggedIn && editable"
    />

    <div
      class="newsfeed__unregistered-view-message card"
      v-if="!isUserLoggedIn"
    >
      <el-link type="primary">
        <router-link :to="{ name: 'Login' }">
          Sign in to add posts
        </router-link>
      </el-link>
    </div>

    <div class="newsfeed__list">
      <newsfeed-post
        v-for="post in postArray"
        :key="post.id"
        :post-data="post"
        entity = "Team"
        access-level = "Public"
        :entity-id="teamId"
        :is-user-logged-in="isUserLoggedIn"
        :id="post.id"
        :editable="editable"
        @update-data="fetchPosts"
      />
    </div>

    <el-divider />
    <div class="newsfeed__pagination">
        <el-button @click="fetchPreviousPosts" :disabled="skip === 0">
          <el-icon><ArrowLeft /></el-icon>
        </el-button>
        <el-button @click="fetchNextPosts" :disabled="postArray?.length < limit">
          <el-icon><ArrowRight /></el-icon>
        </el-button>
      </div>
  </div>
</template>

<script>
import { getTeamNews } from '@/api/team.js';
import NewsfeedPost from '@/components/common/NewsfeedPost.vue';
import PostForm from '@/components/common/PostForm.vue';

export default {
  name: 'TeamNewsfeed',
  props: {
    teamId: {
      type: Number,
      required: true,
    },
    isUserLoggedIn: {
      type: Boolean,
      required: false,
    },
    before: {
      type: Date,
      required: false,
    },
    after: {
      type: Date,
      required: false,
    },
    editable: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    NewsfeedPost,
    PostForm,
  },

  data() {
    return {
      postArray: [],
      skip: 0,
      limit: 10,
    };
  },
  methods: {
    async fetchPosts() {
      const { teamId, before, after, skip, limit } = this;
      const { data, success } = await getTeamNews({ teamId, before, after, skip, limit });

      if (success) {
        this.postArray = data.items;
        this.postArray.sort((a,b) => b.id - a.id);
      }
    },

    async fetchPreviousPosts() {
      if (this.skip >= this.limit) {
        this.skip -= this.limit;
        await this.fetchPosts();
      }
    },
    async fetchNextPosts() {
      this.skip += this.limit;
      await this.fetchPosts();
    },
  },
  created() {
    this.fetchPosts();
  },
};
</script>

<style lang="scss">
.newsfeed {
  margin-top: var(--global-dimension-size-250);

  &__pagination {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top: var(--global-dimension-size-250);
    align-items: center;
  }
}
</style>